<template>
    <v-row no-gutters ref="mapContainer">
      <v-col cols="4">
        <v-toolbar dense color="primary" dark height="35">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-tooltip top>
              <v-btn depressed tile small color="primary"
                     @click="addComment()" slot="activator">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span>New Comment</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn depressed tile small color="primary"
                     @click="deleteComment" transition="slide-x-transition" :disabled="selectedComment === null" slot="activator" flat>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <span>Remove Selected Comment</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <comment-table @row-select="selectComment"
                       @row-mouseover="highlightComment"
                       @row-mouseout="highlightComment"
                       @comment-update="addComment"
                       @deselect="deselectComment"
                       :selectedComment="selectedComment"
                       :comments="getNewQuestion.comments"></comment-table>
      </v-col>
      <v-col class="pl-2">
        <map-component :height="getHeight" no-undo
                       :select="enableSelect"
                       :selectLayers="['comments']"
                       @selected="mapSelect"
                       @go-home="handleGoHome"
                       @map-toolbar-clear="clearComments"
                       @map-created="mapCreated"></map-component>
      </v-col>
    </v-row>
</template>

<script>
  import {mapActions, mapMutations, mapGetters} from 'vuex'
  import MapComponent from '../Map'
  import CommentTable from './CommentPlotTable'
  import GeoJSON from "ol/format/GeoJSON.js";

  export default {
    name: "MapPlotCommentsNew",

    components: {
      CommentTable,
      MapComponent,
    },

    computed: {
      ...mapGetters(['getRoutes', 'getNewQuestion', 'getStartPointStyle', 'getEndPointStyle', 'getIcons']),
      getHeight() {
        let windowHeight = document.body.offsetHeight;
        let offset = 140;

        return `${windowHeight - offset}px`
      }
    },

    data() {
      return {
        enableSelect: true,
        drawLayer: null,
        commentsLayer: null,
        routesLayer: null,
        preventNext: true,
        map: null,
        selectedComment: null,
        commentStyle: () => {
          let style = new GOX.Style();

          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.comment),
              anchor: [0, 23],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        commentSelectedStyle: () => {
          let style = new GOX.Style();

          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.commentSelected),
              anchor: [0, 23],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        startPointStyle: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.start),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        endPointStyle: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.end),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        }
      }
    },

    methods: {
      ...mapMutations(['cancelNewQuestion', 'addQuestionRoutes', 'CREATOR_ADD_COMMENT', 'CREATOR_CLEAR_COMMENTS', 'CREATOR_REMOVE_COMMENT', 'SET_TASK']),
      ...mapActions(['SAVE_QUESTION', 'CANCEL_CREATE', 'LOG_EDIT']),
      addComment(comment) {
        let idnr, text;

        let cmt = comment || {
          idnr: Math.random(),
          text: ''
        };

        //Loop through the current features and add the text to it if its found.
        this.drawLayer.getSource().getFeatures().forEach(feature => {
          if (cmt.idnr === feature.get('idnr')) {
            feature.set('text', cmt.text)
          }
        });

        this.$store.commit('CREATOR_ADD_COMMENT', cmt);

        this.selectedComment = cmt;

        if (!comment) {
          //It's a new comment, so enable editing
          this.preventNext = true;
          this.drawLayer.startDrawing(this.selectedComment);
        }
      },
      removeComment() {
        this.$store.commit('CREATOR_REMOVE_COMMENT', this.selectedComment.idnr)
      },
      createLayers() {
        return new Promise((resolve, reject) => {

          //Start and End points
          this.pointsLayer = new GOX.Layer.Vector({
            id: 'points',
            geometry: 'Point'
          });
          this.map.addLayer(this.pointsLayer);

          //Routes layer
          this.routesLayer = new GOX.Layer.Vector({
            id: 'routes',
            geometry: 'LineString'
          });
          this.map.addLayer(this.routesLayer);

          //Comments layer
          this.drawLayer = new GOX.Layer.Vector({
            id: 'comments',
            geometry: 'Point'
          });
          this.map.addLayer(this.drawLayer);

          this.drawLayer.on('draw-end', (e) => {
            this.preventNext = false;
            this.drawLayer.stopDrawing();
          });

          this.drawLayer.on('draw-stop', (e) => {
            this.selectedComment.coordinates = e.feature.getGeometry().getCoordinates();
            e.feature.setStyle(this.commentStyle);

            //Set the text to the feature so it can be displayed in the preview
            e.feature.set('text', this.selectedComment.text);

            this.addComment(this.selectedComment);
          });

          resolve();
        });
      },
      clearComments() {
        console.log("clear")
        this.$confirm({
          title: 'Clear All Comments',
          message: 'Are you sure you want to remove all comments? This cannot be undone.',
          confirmText: 'Delete'
        }).then(() => {
          this.deselectComment();
          this.CREATOR_CLEAR_COMMENTS();
          this.drawLayer.getSource().clear();
        })
      },
      deleteComment () {
        let featureToRemove = this.getFeatureFromMap(this.selectedComment.idnr);
        this.drawLayer.getSource().removeFeature(featureToRemove);
        this.CREATOR_REMOVE_COMMENT(this.selectedComment.idnr);
        this.deselectComment();
      },
      getFeatureFromMap: function (idnr) {
        let features = this.drawLayer.getSource().getFeatures();
        let retFeature;
        features.forEach(feature => {
          if (feature.get('idnr') === idnr){
            retFeature = feature;
          }
        });

        return retFeature
      },
      highlightComment(comment) {
        let features = this.drawLayer.getSource().getFeatures();

        features.forEach(feature => {
          if (comment && feature.get('idnr') === comment.idnr) {
            feature.setStyle(this.commentSelectedStyle);
          } else {
            feature.setStyle(this.commentStyle);
          }
        })
      },
      handleSaveQuestion() {
        var params = this.getNewQuestion;
        params.userid = "tom@tfl";
        params.savedToDatabase = true;
        this.SAVE_QUESTION(this.getNewQuestion).then(() => {
          this.questionSaved = true;
          this.LOG_EDIT(this.getNewQuestion);
          this.$router.push('/');
          this.SET_TASK('');
        }).catch((error) => {
          this.$confirm({
            title: 'ERROR',
            message: error
          });
        });
      },
      fetchExistingRoutes() {
        let routes = this.getNewQuestion.routes;

        for (var route in routes) {
          var features = new GeoJSON().readFeatures(routes[route].geoJSON, {
            dataProjection: 'EPSG:27700',
            featureProjection: 'EPSG:27700'
          });

          this.routesLayer.getSource().addFeatures(features);
          features.forEach((feat) => {
            this.preventNext = false;
            this.setRouteStyle(feat, routes[route].colour)
          })
        }

        if (routes.length) {
          this.map.setExtent(this.routesLayer.getFeaturesExtent());
        }

      },
      fetchExistingComments() {
        let comments = this.getNewQuestion.comments;

        comments.forEach((comment) => {
          console.log(comment)
          //let commentGeometry = new GOX.Geom.Point();
          let commentFeature = new GOX.Feature.Point();

          if (comment.geoJSON) {
            let parsed = JSON.parse(comment.geoJSON);
            commentFeature.getGeometry().setCoordinates(parsed.geometry.coordinates);
          } else {
            commentFeature.getGeometry().setCoordinates(comment.coordinates);
          }


          commentFeature.setStyle(this.commentStyle);
          commentFeature.set('text', comment.text)
          commentFeature.set('idnr', comment.idnr)

          this.drawLayer.getSource().addFeature(commentFeature);
        });
      },
      fetchStartAndEndPoints() {
        console.log("GET START END POINTS")
        let startPoint = this.getNewQuestion.startpoint;
        let endPoint = this.getNewQuestion.endpoint;

        let sFeatures = new GeoJSON().readFeatures(startPoint, {
          dataProjection: 'EPSG:27700',
          featureProjection: 'EPSG:27700'
        });

        sFeatures.forEach((feature) => {
          feature.setStyle(this.startPointStyle);
        });

        let eFeatures = new GeoJSON().readFeatures(endPoint, {
          dataProjection: 'EPSG:27700',
          featureProjection: 'EPSG:27700'
        });

        eFeatures.forEach((feature) => {
          feature.setStyle(this.endPointStyle);
        });

        this.pointsLayer.getSource().addFeatures(sFeatures);
        this.pointsLayer.getSource().addFeatures(eFeatures);

        this.map.setExtent(this.pointsLayer.getFeaturesExtent());

      },
      getGeoJSONFromFeature(feature) {
        return new Promise((resolve, reject) => {
          //Handle no feature
          if (!feature) {
            resolve(null);
          }

          var geoJSON = new GeoJSON().writeFeature(feature, {
            dataProjection: 'EPSG:27700',
            featureProjection: 'EPSG:27700'
          });
          console.log("MapPlotRoutesNew -- : GEOJSON");
          console.dir(geoJSON)
          resolve(geoJSON);
        });
      },
      goBack() {
        //Dont clear new Question, return to previous
        this.$router.go(-1)
      },
      goNext() {
        this.$router.push({
          name: 'comments'
        })
      },
      handleGoHome() {
        var src = this.pointsLayer.getSource();
        if (src.getFeatures().length > 1) {
          this.map.setExtent(this.pointsLayer.getSource().getExtent());
        } else {
          this.map.setExtent(this.pointsLayer.getSource().getExtent(), 15);
        }
      },
      mapCreated(map) {
        console.log("MAP CREATED")
        this.map = map;

        this.createLayers().then(() => {
          this.fetchStartAndEndPoints();
          this.fetchExistingRoutes();
          this.fetchExistingComments();
        });
      },
      mapSelect(e) {
        if (e.selected && e.selected.length) {
          console.log('Select Comment')
          console.dir(e.selected[0].values_)
          this.selectComment(e.selected[0].values_);
        } else {
          this.selectComment();
        }
      },
      deselectComment() {
        var selectedFeatures = this.map.gox_interactions.select.getFeatures();
        console.dir(selectedFeatures);

        //this sets resets the highlight for any currently selected features.
        selectedFeatures.forEach((feature) => {
          feature.setStyle(this.commentStyle)
        });
        this.selectedComment = null;
        selectedFeatures.clear();

        //Dispatch a select event to force the map alert to disappear.
        this.map.gox_interactions.select.dispatchEvent('select', {
          selected: []
        });
      },
      selectComment(comment) {
        // Clear highlights
        this.highlightComment();

        if (comment) {
          this.selectedComment = comment;
          this.highlightComment(comment);
          //this.selectOnMap(comment)
        } else {
          this.selectedComment = null;
        }
      },
      selectOnMap(comment) {
        let features = this.drawLayer.getSource().getFeatures();
        this.map.gox_interactions.select.getFeatures().clear();
        features.forEach(feature => {
          console.log(feature.get('idnr'))
          if (comment.idnr === feature.get('idnr')) {
            feature.setStyle(this.commentSelectedStyle);
            this.map.gox_interactions.select.dispatchEvent('select', {
              selected: [feature]
            });
            console.dir(this.map.gox_interactions.select.getFeatures())
          }
        })
      },
      setRouteStyle(feature, color) {
        let styleCon = new GOX.Style();
        var style = styleCon.JSONtoStyle({
          stroke: {
            width: 5,
            color: color
          }
        });

        feature.setStyle(style);
      },
      undo() {
        this.drawLayer.removeLastDrawnPoint();
      }
    }
  }
</script>

<style scoped>

</style>
